import { render, staticRenderFns } from "./ImagePreviewToolbarComponent.vue?vue&type=template&id=b87114bc&lang=pug"
import script from "./ImagePreviewToolbarComponent.vue?vue&type=script&lang=ts"
export * from "./ImagePreviewToolbarComponent.vue?vue&type=script&lang=ts"
import style0 from "./ImagePreviewToolbarComponent.vue?vue&type=style&index=0&id=b87114bc&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b87114bc')) {
      api.createRecord('b87114bc', component.options)
    } else {
      api.reload('b87114bc', component.options)
    }
    module.hot.accept("./ImagePreviewToolbarComponent.vue?vue&type=template&id=b87114bc&lang=pug", function () {
      api.rerender('b87114bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/Preview/components/ImagePreviewComponent/ImagePreviewToolbarComponent.vue"
export default component.exports